import * as React from 'react';
import useClickOutside from '../../../../../Hooks/useClickOutside';
import { filterCollectionsData } from '../../../../../Shared/DiscoverPageFakeData';
import { AnimatePresence, motion } from "framer-motion"
import { useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

export interface IFilterSectionProps {
    setFilterModalOpen: any,
}

export function FilterSection(props: IFilterSectionProps) {
    let [searchParams, setSearchParams] = useSearchParams();
    let navigate = useNavigate()

    // explore filter modal
    // basic
    const [saleTypeDropOpen, setSaleTypeDropOpen] = React.useState(false)
    const [saleTypeText, setSaleTypeText] = React.useState('Buy');
    let saleTypeDropRef = React.useRef<HTMLHeadingElement>(null)
    useClickOutside(saleTypeDropRef, () => setSaleTypeDropOpen(false))

    const [typeDropOpen, setTypeDropOpen] = React.useState(false)
    const [typeText, setTypeText] = React.useState('All');
    let typeDropRef = React.useRef<HTMLHeadingElement>(null)
    useClickOutside(typeDropRef, () => setTypeDropOpen(false))

    const [bundleItemsDropOpen, setBundleItemsDropOpen] = React.useState(false)
    const [bundleItemsText, setBundleItemsText] = React.useState('All');
    let bundleItemsRef = React.useRef<HTMLHeadingElement>(null)
    useClickOutside(bundleItemsRef, () => setBundleItemsDropOpen(false))

    const [sortDropOpen, setSortDropOpen] = React.useState(false)
    const [sortText, setSortText] = React.useState('Newest');
    let sortDropRef = React.useRef<HTMLHeadingElement>(null)
    useClickOutside(sortDropRef, () => setSortDropOpen(false))




    const [collectionsData, setCollectionsData] = React.useState<any>(filterCollectionsData)
    const [selectedItemName, setSelectedItemName] = useState('')
    const [selectedCollectionsId, setSelectedCollectionsId] = useState(-1)
    // handle Search collections
    const [collectionInputValue, setCollectionInputValue] = useState('')
    const handleSearchCollections = (e: any) => {
        setCollectionInputValue(e.target.value);
        const previousCollectionsData = [...filterCollectionsData];
        const findMatchData = previousCollectionsData.filter(data => data.collectionName.toLowerCase().includes(e.target.value.toLowerCase()))
        setCollectionsData(findMatchData);
    }

    // handle collections items show
    const [selectedCollections, setSelectedCollections] = React.useState<any>([])
    const handleCollectionOnClick = (id: number) => {
        setSelectedCollectionsId(id)
        const previousCollectionsData = [...collectionsData];
        const findClickedCollection = previousCollectionsData.find(coll => coll.id === id)
        findClickedCollection.isActive = !findClickedCollection.isActive;

        const prevSelectedCollections = [...selectedCollections]
        if (findClickedCollection.isActive) {
            if (prevSelectedCollections.indexOf(findClickedCollection) === -1) {
                prevSelectedCollections.push(findClickedCollection)
                setSelectedCollections(prevSelectedCollections);
            }
        }
        else {
            const withoutUnActiveData = prevSelectedCollections.filter(data => data.id !== id)
            setSelectedCollections(withoutUnActiveData);
        }
        setCollectionsData(previousCollectionsData);
    }





    // Hanlde Navigator and show collection items
    const [selectedColleItems, setSelectedColleItems] = React.useState<any>({
        collectionChecked: true,
        otherItems: {}
    })
    const hanldeFilterItemOnClick = (id: string, itemName?: any) => {
        setSelectedItemName(itemName)
        const selectedCollectionItems = selectedCollections[0]?.aditionalFilterItems;
        if (id === 'collections') {
            setSelectedColleItems({
                collectionChecked: true,
                otherItems: {}
            });
        }
        else {
            const findSlectedColleItem = selectedCollectionItems.find((item: any) => item.itemName.toLowerCase() === itemName.toLowerCase())
            setSelectedColleItems({
                collectionChecked: false,
                otherItems: findSlectedColleItem
            });
        }
    }

    // hanlde collections items search  lastSearchValue
    const hanldeCollectionItemsSearch = (e: any) => {
        const previousCollectionsData = [...filterCollectionsData];
        const findMatchCollection = previousCollectionsData.find(colle => colle.id === selectedCollectionsId)
        const findSlectedColleItem = findMatchCollection?.aditionalFilterItems.find((item: any) => item.itemName.toLowerCase() === selectedItemName.toLowerCase())
        const filterOutMatchItmes = findSlectedColleItem?.itemOptions.filter((data: any) => data.optionName.toLowerCase().includes(e.target.value.toLowerCase()))

        const prevSelectedColleItems = { ...selectedColleItems.otherItems }
        prevSelectedColleItems.itemOptions = filterOutMatchItmes
        prevSelectedColleItems.lastSearchValue = e.target.value
        setSelectedColleItems({
            collectionChecked: false,
            otherItems: prevSelectedColleItems
        });
    }




    // hanlde filters apply
    const handleFiltersApply = (e: any) => {
        e.preventDefault()
        const minPriceInput = document.getElementById('minPriceInput') as HTMLInputElement;
        const maxPriceInput = document.getElementById('maxPriceInput') as HTMLInputElement;

        let prices: any = '';
        if (minPriceInput.value.length > 0 && maxPriceInput.value.length > 0) {
            prices = `&&minPrice=${minPriceInput.value}&&maxPrice=${maxPriceInput.value}`
        }

        let collections: any = '&&collections=';
        if (selectedCollections.length === 1) {
            selectedCollections.map((colle: any) => {
                collections += colle.id + ' '
            })
        }
        else if (selectedCollections.length > 1) {
            selectedCollections.map((colle: any) => {
                collections += colle.id + ' '
            })
        }
        navigate(`/discover?type=${typeText}&&saleType=${saleTypeText}&&bundleItmes=${bundleItemsText}&&sort=${sortText}${prices !== '' ? prices : ''}${collections === "&&collections=" ? '' : collections.replace(/\s/g, '-')}`)


        props.setFilterModalOpen(false)
    }













    return (
        <div>

            <div className="flex justify-between items-center">
                <div className="relative inline-block">
                    <h1 className="xs:text-2xl xl:text-3xl mr-3 font-extrabold text-cusBlack dark:text-white">Filters</h1>
                    <div className="bottom-1 absolute -right-2.5">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width={12} height={12} viewBox="0 0 12 12">
                            <defs>
                                <linearGradient id="linear-gradient" x1="0.875" y1="0.174" x2="0.139" y2="0.84" gradientUnits="objectBoundingBox">
                                    <stop offset={0} stopColor="#00dbff" />
                                    <stop offset="0.529" stopColor="#e315e8" />
                                    <stop offset={1} stopColor="#ffd817" />
                                </linearGradient>
                            </defs>
                            <circle id="Ellipse_1" data-name="Ellipse 1" cx={6} cy={6} r={6} fill="url(#linear-gradient)" />
                        </svg>
                    </div>
                </div>

                <button onClick={() => props.setFilterModalOpen(false)}
                    className="border border-gray-400 hover:bg-gray-300 dark:hover:bg-cusGray transition-all rounded-full p-2.5">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14.855" className="blackWhiteSVG2" height="14.856" viewBox="0 0 21.855 21.856">
                        <line id="Line_74" data-name="Line 74" x2="17.613" y2="17.613" transform="translate(2.121 2.121)" fill="none" stroke="#fcfcfc" strokeLinecap="round" strokeWidth={3} />
                        <line id="Line_75" data-name="Line 75" x1="17.613" y2="17.613" transform="translate(2.121 2.121)" fill="none" stroke="#fcfcfc" strokeLinecap="round" strokeWidth={3} />
                    </svg>
                </button>
            </div>


            <form onSubmit={handleFiltersApply}>
                <div className="mt-4 md:mt-3 xl:mt-8 flex flex-col sm:flex-row justify-between items-start">

                    <div className="sm:border-r-2 border-[#e6e8ec] dark:border-[#e6e8ec20] w-full sm:w-[170px] md:w-[220px] lg:w-[280px] pr-3 lg:pr-6">
                        <h4 className="text-base md:text-lg lg:text-xl uppercase text-cusBlack dark:text-white dark:font-medium font-semibold">Basic</h4>

                        <div className="mt-4 lg:mt-6">
                            <p className="text-l-LightBlack uppercase dark:text-cusBlueWhite text-xs md:text-sm">Type</p>
                            <div
                                ref={typeDropRef}
                                className="border-2 border-[#e6e8ec] hover:border-gray-300 dark:hover:border-gray-400
                                            dark:border-[#e6e8ec20] px-3 py-2 rounded-md md:rounded-lg mt-0.5 transition-all cursor-pointer relative w-full text-left"
                                onClick={() => setTypeDropOpen(!typeDropOpen)}>
                                <div className="flex justify-between items-center break-all">
                                    <h4 className="text-l-LightBlack dark:text-white font-semibold text-xs md:text-sm">{typeText}</h4>
                                    <svg xmlns="http://www.w3.org/2000/svg" className={`h-4 w-4 blackWhiteSVG3 transition-all ${typeDropOpen && 'rotate-180'}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                                    </svg>
                                </div>
                                <AnimatePresence>
                                    {typeDropOpen &&
                                        <motion.div
                                            animate={typeDropOpen ? "open" : "closed"}
                                            initial={{ y: -15, }}
                                            variants={{
                                                open: { y: 0, },
                                                closed: { y: -100, },
                                            }}
                                            exit={{ opacity: 0, y: -15 }}
                                            transition={{ duration: 0.2 }}
                                            className="rounded-xl overflow-hidden absolute top-10 bg-white dark:bg-[#292757] shadow-lg
                                                        dark:shadow-[#00000060] border border-[#e6e8ec] dark:border-[#e6e8ec20] w-full left-0 z-20">
                                            {["All", "Fixed Price", "Acution", "With Buy Offer"].map(item =>
                                                <div onClick={() => { setTypeText(item) }}
                                                    className="py-2 px-4 break-all hover:bg-[#e6e8ec] dark:hover:bg-cusBlack transition-all" key={item}>
                                                    <p className="text-cusBlack dark:text-white text-xs lg:text-sm xl:text-base font-medium">{item}</p>
                                                </div>
                                            )}
                                        </motion.div>}
                                </AnimatePresence>
                            </div>
                        </div>

                        <div className="mt-3">
                            <p className="text-l-LightBlack uppercase dark:text-cusBlueWhite text-xs md:text-sm">Sale Type</p>
                            <div
                                ref={saleTypeDropRef}
                                className="border-2 border-[#e6e8ec] hover:border-gray-300 dark:hover:border-gray-400
                                            dark:border-[#e6e8ec20] px-3 py-2 rounded-md md:rounded-lg mt-0.5 transition-all cursor-pointer relative w-full text-left"
                                onClick={() => setSaleTypeDropOpen(!saleTypeDropOpen)}>
                                <div className="flex justify-between items-center break-all">
                                    <h4 className="text-l-LightBlack dark:text-white font-semibold text-xs md:text-sm">{saleTypeText}</h4>
                                    <svg xmlns="http://www.w3.org/2000/svg" className={`h-4 w-4 blackWhiteSVG3 transition-all ${saleTypeDropOpen && 'rotate-180'}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                                    </svg>
                                </div>
                                <AnimatePresence>
                                    {saleTypeDropOpen &&
                                        <motion.div
                                            animate={saleTypeDropOpen ? "open" : "closed"}
                                            initial={{ y: -15, }}
                                            variants={{
                                                open: { y: 0, },
                                                closed: { y: -100, },
                                            }}
                                            exit={{ opacity: 0, y: -15 }}
                                            transition={{ duration: 0.2 }}
                                            className="rounded-xl overflow-hidden absolute top-10 bg-white dark:bg-[#292757] shadow-lg
                                                        dark:shadow-[#00000060] border border-[#e6e8ec] dark:border-[#e6e8ec20] w-full left-0 z-20">
                                            {["Buy", "Auction", "Mint"].map(item =>
                                                <div onClick={() => { setSaleTypeText(item) }}
                                                    className="py-2 px-4 break-all hover:bg-[#e6e8ec] dark:hover:bg-cusBlack transition-all" key={item}>
                                                    <p className="text-cusBlack dark:text-white text-xs lg:text-sm xl:text-base font-medium">{item}</p>
                                                </div>
                                            )}
                                        </motion.div>}
                                </AnimatePresence>
                            </div>
                        </div>

                        <div className="mt-3">
                            <p className="text-l-LightBlack uppercase dark:text-cusBlueWhite text-xs md:text-sm">BUNDLE & ITEMS</p>
                            <div
                                ref={bundleItemsRef}
                                className="border-2 border-[#e6e8ec] hover:border-gray-300 dark:hover:border-gray-400
                                            dark:border-[#e6e8ec20] px-3 py-2 rounded-md md:rounded-lg mt-0.5 transition-all cursor-pointer relative w-full text-left"
                                onClick={() => setBundleItemsDropOpen(!bundleItemsDropOpen)}>
                                <div className="flex justify-between items-center break-all">
                                    <h4 className="text-l-LightBlack dark:text-white font-semibold text-xs md:text-sm">{bundleItemsText}</h4>
                                    <svg xmlns="http://www.w3.org/2000/svg" className={`h-4 w-4 blackWhiteSVG3 transition-all ${bundleItemsDropOpen && 'rotate-180'}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                                    </svg>
                                </div>
                                <AnimatePresence>
                                    {bundleItemsDropOpen &&
                                        <motion.div
                                            animate={bundleItemsDropOpen ? "open" : "closed"}
                                            initial={{ y: -15, }}
                                            variants={{
                                                open: { y: 0, },
                                                closed: { y: -100, },
                                            }}
                                            exit={{ opacity: 0, y: -15 }}
                                            transition={{ duration: 0.2 }}
                                            className="rounded-xl overflow-hidden absolute top-10 bg-white dark:bg-[#292757] shadow-lg
                                                        dark:shadow-[#00000060] border border-[#e6e8ec] dark:border-[#e6e8ec20] w-full left-0 z-20">
                                            {["All", "Single Item", "Bundle"].map(item =>
                                                <div onClick={() => { setBundleItemsText(item) }}
                                                    className="py-2 px-4 break-all hover:bg-[#e6e8ec] dark:hover:bg-cusBlack transition-all" key={item}>
                                                    <p className="text-cusBlack dark:text-white text-xs lg:text-sm xl:text-base font-medium">{item}</p>
                                                </div>
                                            )}
                                        </motion.div>}
                                </AnimatePresence>
                            </div>
                        </div>

                        <div className="mt-3">
                            <p className="text-l-LightBlack uppercase dark:text-cusBlueWhite text-xs md:text-sm">SORT</p>
                            <div
                                ref={sortDropRef}
                                className="border-2 border-[#e6e8ec] hover:border-gray-300 dark:hover:border-gray-400
                                            dark:border-[#e6e8ec20] px-3 py-2 rounded-md md:rounded-lg mt-0.5 transition-all cursor-pointer relative w-full text-left"
                                onClick={() => setSortDropOpen(!sortDropOpen)}>
                                <div className="flex justify-between items-center break-all">
                                    <h4 className="text-l-LightBlack dark:text-white font-semibold text-xs md:text-sm">{sortText}</h4>
                                    <svg xmlns="http://www.w3.org/2000/svg" className={`h-4 w-4 blackWhiteSVG3 transition-all ${sortDropOpen && 'rotate-180'}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                                    </svg>
                                </div>
                                <AnimatePresence>
                                    {sortDropOpen &&
                                        <motion.div
                                            animate={sortDropOpen ? "open" : "closed"}
                                            initial={{ y: -15, }}
                                            variants={{
                                                open: { y: 0, },
                                                closed: { y: -100, },
                                            }}
                                            exit={{ opacity: 0, y: -15 }}
                                            transition={{ duration: 0.2 }}
                                            className="rounded-xl overflow-hidden absolute top-10 bg-white dark:bg-[#292757] shadow-lg
                                                        dark:shadow-[#00000060] border border-[#e6e8ec] dark:border-[#e6e8ec20] w-full left-0 z-20">
                                            {["Newest", "Price: Low to High", "Price: High to Low", "Ending Soon",].map(item =>
                                                <div onClick={() => { setSortText(item) }}
                                                    className="py-2 px-4 break-all hover:bg-[#e6e8ec] dark:hover:bg-cusBlack transition-all" key={item}>
                                                    <p className="text-cusBlack dark:text-white text-xs lg:text-sm xl:text-base font-medium">{item}</p>
                                                </div>
                                            )}
                                        </motion.div>}
                                </AnimatePresence>
                            </div>
                        </div>

                        <div className="mt-3">
                            <p className="text-l-LightBlack uppercase dark:text-cusBlueWhite text-xs md:text-sm">PRICE</p>
                            <div className="flex justify-between items-center mt-2">

                                <input type="number" className="border-2 grow w-full
                                border-[#e6e8ec] dark:border-[#e6e8ec20] text-xs md:text-sm
                                hover:border-gray-300 dark:hover:border-gray-400 focus:border-gray-300 dark:focus:border-gray-400
                            px-2 py-1.5 md:px-3 md:py-2 rounded-md md:rounded-lg bg-transparent outline-none text-l-LightBlack dark:text-white"
                                    placeholder="Min" id="minPriceInput" />

                                <h4 className="grow-0 px-2 lg:px-3 text-xs md:text-sm uppercase text-l-LightBlack dark:text-cusBlueWhite dark:font-medium font-semibold">To</h4>

                                <input type="number" className="border-2 grow w-full
                                    border-[#e6e8ec] dark:border-[#e6e8ec20] text-xs md:text-sm
                                    hover:border-gray-300 dark:hover:border-gray-400 focus:border-gray-300 dark:focus:border-gray-400
                                px-2 py-1.5 md:px-3 md:py-2 rounded-md md:rounded-lg bg-transparent outline-none text-l-LightBlack dark:text-white"
                                    placeholder="Max" id="maxPriceInput" />

                            </div>
                        </div>

                    </div>



                    <div className="flex-1 sm:pl-4 lg:pl-8 mt-6 sm:mt-0 w-full">
                        <h4 className="text-base md:text-lg lg:text-xl uppercase text-cusBlack dark:text-white dark:font-medium font-semibold">DETAIL</h4>

                        <div className="mt-5 grid grid-cols-3">
                            <div className="border-r-2 border-[#e6e8ec] dark:border-[#e6e8ec20] flex flex-col justify-start items-center overflow-auto h-[240px] sm:h-[270px] md:h-[300px] lg:h-[360px]">

                                <input type="radio" name="filterItemNavigator" id="collections" className="hidden" defaultChecked />
                                <label htmlFor="collections"
                                    onClick={() => hanldeFilterItemOnClick('collections')}
                                    className="p-2.5 md:p-3.5 w-full rounded-l-lg uppercase cursor-pointer text-left text-xs md:text-sm font-semibold
                                                     dark:font-medium flex justify-between items-center filterItemNavigatorLabel">
                                    <p className={`${selectedCollections.length > 0 ? 'text-cusBlack dark:text-white' : 'text-gray-500 dark:text-cusBlueWhite'}`}>Collections</p>
                                    {selectedCollections.length > 0 &&
                                        <p className="text-[#9198a7] text-xs sm:text-sm">{selectedCollections.length}</p>}
                                </label>

                                {selectedCollections.length === 1 &&
                                    selectedCollections[0].aditionalFilterItems.map((item: any, index: number) =>
                                        <div key={item.itemName} className="w-full my-0.5">
                                            <input
                                                onClick={() => hanldeFilterItemOnClick(`${item.itemName}${index}`, item.itemName)}
                                                type="radio"
                                                name="filterItemNavigator"
                                                id={`${item.itemName}${index}`}
                                                className="hidden" />
                                            <label htmlFor={`${item.itemName}${index}`} className="p-2.5 md:p-3.5 w-full rounded-l-lg uppercase cursor-pointer text-left text-xs lg:text-sm font-semibold dark:font-medium flex justify-between items-center text-l-LightBlack dark:text-cusBlueWhite filterItemNavigatorLabel">
                                                {item.itemName}
                                            </label>
                                        </div>
                                    )
                                }
                            </div>


                            <div className="col-span-2 pl-4 sm:pl-5 md:pl-5 lg:pl-10">
                                <div className="">
                                    {selectedColleItems.collectionChecked
                                        // Main Collections-----------------
                                        ? <div className="flex flex-col">
                                            {!selectedColleItems?.otherItems?.isMinMax &&
                                                <div className="relative">
                                                    <input
                                                        onChange={handleSearchCollections}
                                                        defaultValue={collectionInputValue}
                                                        type="text"
                                                        autoComplete="off"
                                                        className="border-2 grow w-full h-full pl-12 border-[#e6e8ec] dark:border-[#e6e8ec20]
                                                                        hover:border-gray-300 dark:hover:border-gray-400 focus:border-gray-300 dark:focus:border-gray-400
                                                                        px-3 py-2.5 rounded-xl bg-transparent outline-none text-l-LightBlack dark:text-white"
                                                        placeholder="Search" id="collectionSearchInput" />

                                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 stroke-[#9198a7] absolute top-3 left-4" fill="none" viewBox="0 0 24 24" stroke="" strokeWidth={2}>
                                                        <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                                    </svg>
                                                </div>
                                            }

                                            <div className="overflow-auto h-[190px] sm:h-[210px] md:h-[240px] lg:h-[300px] pr-3 mt-4">
                                                {collectionsData.length > 0
                                                    ? collectionsData.map((data: any) =>
                                                        <div className=" mb-5 overflow-hidden items-center cursor-pointer collection_item" key={data.id}
                                                            onClick={() => handleCollectionOnClick(data.id)}>

                                                            <div className="flex justify-between w-full">
                                                                <div className="flex justify-start items-center w-full flex-1">
                                                                    <div className="w-5 h-5 md:w-7 md:h-7 overflow-hidden rounded-full relative">
                                                                        {data.isActive &&
                                                                            <svg xmlns="http://www.w3.org/2000/svg" className="w-3 h-3 md:h-5 md:w-5 absolute opacity-100 blackWhiteSVG3 top-1 left-1" fill="none" viewBox="0 0 24 24" stroke="" strokeWidth={3}>
                                                                                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                                                                            </svg>
                                                                        }
                                                                        <div className="w-full h-full">
                                                                            <img src={data.logo} alt="" className={`w-full h-full ${data?.isActive ? 'blur-lg' : ''}`} />
                                                                        </div>
                                                                    </div>
                                                                    <h5 className="text-l-LightBlack text-left
                                                                truncate max-w-[60px] xxsm:max-w-[120px] xsm:max-w-[130px] md:max-w-[160px] lg:max-w-[240px]
                                                                dark:text-white ml-2.5 mr-2 text-xs sm:text-xs lg:text-base break-all">{data.collectionName}</h5>
                                                                </div>

                                                                <div className="">
                                                                    <p className="text-[#9198a7] text-xs md:text-sm">{data.resultsNum}</p>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    )
                                                    : <div className="flex flex-col justify-center items-center w-full h-full">
                                                        <p className="mt-0 dark:text-cusBlueWhite text-l-LightBlack">No collections found</p>
                                                    </div>
                                                }
                                            </div>
                                        </div>






                                        : selectedColleItems !== {} &&
                                            selectedColleItems.otherItems.isMinMax
                                            ? <div className="flex justify-between items-center">

                                                <input type="number" className="border-2 grow w-full border-[#e6e8ec] dark:border-[#e6e8ec20]
                                                hover:border-gray-300 dark:hover:border-gray-400 focus:border-gray-300 dark:focus:border-gray-400
                                                 px-2 py-1.5 md:px-3 md:py-2.5 rounded-md md:rounded-lg lg:rounded-xl bg-transparent outline-none text-l-LightBlack dark:text-white"
                                                    placeholder="Min" />

                                                <h4 className="grow-0 px-3 text-base uppercase text-l-LightBlack dark:text-cusBlueWhite dark:font-medium font-semibold">To</h4>

                                                <input type="number" className="border-2 grow w-full border-[#e6e8ec] dark:border-[#e6e8ec20]
                                            hover:border-gray-300 dark:hover:border-gray-400 focus:border-gray-300 dark:focus:border-gray-400
                                             px-2 py-1.5 md:px-3 md:py-2.5 rounded-md md:rounded-lg lg:rounded-xl bg-transparent outline-none text-l-LightBlack dark:text-white"
                                                    placeholder="Max" />
                                            </div>

                                            : <div className="w-full flex flex-col">
                                                {!selectedColleItems.otherItems.isFilterSupport
                                                    ? <div className="w-full flex flex-col justify-center">
                                                        <div className="relative">
                                                            <input
                                                                onChange={(e) => hanldeCollectionItemsSearch(e)}
                                                                value={selectedColleItems.otherItems.lastSearchValue}
                                                                type="text"
                                                                autoComplete="off"
                                                                className="border-2 grow w-full h-full pl-12 border-[#e6e8ec] dark:border-[#e6e8ec20]
                                                        hover:border-gray-300 dark:hover:border-gray-400 focus:border-gray-300 dark:focus:border-gray-400
                                                        px-3 py-2.5 rounded-xl bg-transparent outline-none text-l-LightBlack dark:text-white"
                                                                placeholder="Search" id="collectionItemSearchInput" />

                                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 stroke-[#9198a7] absolute top-3 left-4" fill="none" viewBox="0 0 24 24" stroke="" strokeWidth={2}>
                                                                <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                                            </svg>
                                                        </div>
                                                        {selectedColleItems.otherItems.itemOptions.length > 0
                                                            ? <div className="flex flex-col space-y-7 overflow-auto h-[190px] sm:h-[210px] lg:h-[300px] pr-3 mt-4">
                                                                {
                                                                    selectedColleItems.otherItems.itemOptions.map((option: any, index: number) =>
                                                                        <div className="flex justify-between items-center" key={option.optionName}>
                                                                            <div className="flex justify-start items-center cursor-pointer pl-1">
                                                                                <input
                                                                                    type="checkbox" name="" id={`itemOptions${index}`}
                                                                                    className="w-4 h-4 text-purple-600 bg-gray-100 rounded form-checkbox
                                                                                     border-gray-300 focus:ring-purple-500 dark:focus:ring-purple-600 transition-all
                                                                                     focus:ring-2 dark:bg-transparent dark:border-gray-200 dark:text-purple-600" />

                                                                                <label htmlFor={`itemOptions${index}`} className="text-l-LightBlack dark:text-white font-semibold text-xs lg:text-base select-none ml-2" >
                                                                                    {option.optionName}
                                                                                </label>
                                                                            </div>
                                                                            <p className="text-[#9198a7] text-xs sm:text-sm">{option.optionResultNum}</p>
                                                                        </div>
                                                                    )
                                                                }
                                                            </div>
                                                            : <div className="mt-5 text-center">
                                                                <p className="mt-0 dark:text-cusBlueWhite text-l-LightBlack">No match data found</p>
                                                            </div>
                                                        }
                                                    </div>
                                                    : <div>
                                                        <p className="text-l-LightBlack dark:text-white">date filter not supported yet</p>
                                                    </div>
                                                }


                                            </div>
                                    }
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <div className="flex justify-end items-center mt-4 sm:mt-1 lg:mt-3 space-x-4">
                    <p className="text-[#9198a7] text-xs sm:text-sm font-semibold lg:text-base">25550 results</p>

                    <button
                        type="submit"
                        className="gradientBtn text-sm lg:text-base px-4 py-2 lg:px-6 lg:py-3 rounded-full text-white font-semibold">
                        Apply
                    </button>

                    <button
                        type="button"
                        className="border-[#9198a7] border-2 text-sm lg:text-base px-4 py-2 lg:px-6 lg:py-2.5 rounded-full text-cusBlack dark:text-white font-semibold">
                        Reset
                    </button>

                </div>
            </form>
        </div >
    );
}
